(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    let ltcCardGesture;
  document.addEventListener('pointerdown', (event) => {
    ltcCardGesture = null;
    if (!(event.target instanceof Element) || event.target.closest('button')) return;
    const gallery = event.target.closest('.ltc-variant-carousel');
    if (!gallery) return;
    const slideshow = gallery.querySelector('slideshow-component');
    const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    const index = Math.max(0, slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false'));
    ltcCardGesture = { gallery, slideshow, index, count: slides.length, x: event.clientX, y: event.clientY, moved: false, until: 0 };
  }, true);
  document.addEventListener('pointermove', (event) => {
    if (!ltcCardGesture) return;
    const dx = Math.abs(event.clientX - ltcCardGesture.x);
    const dy = Math.abs(event.clientY - ltcCardGesture.y);
    if (dx > 10 && dx > dy) ltcCardGesture.moved = true;
  }, true);
  document.addEventListener('pointerup', (event) => {
    if (!ltcCardGesture) return;
    ltcCardGesture.until = performance.now() + 600;
    const gesture = ltcCardGesture;
    if (!gesture.moved) return;
    const direction = event.clientX < gesture.x ? 1 : -1;
    const nextIndex = (gesture.index + direction + gesture.count) % gesture.count;
    requestAnimationFrame(() => gesture.slideshow.select(nextIndex));
  }, true);
  document.addEventListener('pointercancel', () => {
    ltcCardGesture = null;
  }, true);
  document.addEventListener('click', (event) => {
    if (!ltcCardGesture?.moved || performance.now() > ltcCardGesture.until) return;
    if (!(event.target instanceof Element) || !ltcCardGesture.gallery.contains(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    ltcCardGesture = null;
  }, true);
  } catch(e) { console.error(e); }
})();

})();
